import React from 'react';
import { Menu, Modal } from 'semantic-ui-react';
import Auth from './Auth';

class AuthModal extends React.Component {
  constructor(props) {
    super();

    this.handleModalOpen = this.handleModalOpen.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);

    this.state = {
      modalOpen: false
    }
  }

  componentWillMount() {
    const modalOpen = (this.props.modalOpen) ? this.props.modalOpen : false;
    this.setState({modalOpen})
  }

  handleModalOpen = (e) => this.setState({
    modalOpen: true,
  })

  handleModalClose = (e) => this.setState({
    modalOpen: false,
  })

  render() {
    return (
      <Modal
        dimmer='blurring'
        open={this.state.modalOpen}
        onClose={this.handleModalClose}
        trigger={
          <Menu.Item onClick={this.handleModalOpen}>
            <span className='signUpLogInBtn'>Sign-Up &middot; Log-In</span>
          </Menu.Item>
        }
      >
        <Modal.Header className='ui centered'>
          Welcome Friend!
        </Modal.Header>
        <Modal.Content>
          <Auth handleCancel={this.handleModalClose} />
        </Modal.Content>
      </Modal>
    );
  }
}

export default AuthModal



// WEBPACK FOOTER //
// ./src/components/AuthModal.js